"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceChangePopupMobile = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../Button"));
var _CurrencyFormat = _interopRequireDefault(require("../../CurrencyFormat"));
var _ArrowRightLong = _interopRequireDefault(require("../../../icons-react/userflow/ArrowRightLong"));
var _HotPriceCircle = _interopRequireDefault(require("../../../icons-react/userflow/HotPriceCircle"));
var _constants = require("../constants");
var _utils = require("../utils");
var PriceChangePopupMobile = exports.PriceChangePopupMobile = function PriceChangePopupMobile(props) {
  var oldPrice = props.oldPrice,
    newPrice = props.newPrice,
    onOrderConfirmed = props.onOrderConfirmed,
    hotelLink = props.hotelLink,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  var _getPriceDirection = (0, _utils.getPriceDirection)({
      oldPrice: oldPrice,
      newPrice: newPrice
    }),
    priceDirection = _getPriceDirection.priceDirection,
    isIncreased = _getPriceDirection.isIncreased;
  var _PRICE_MOBILE$priceDi = _constants.PRICE_MOBILE[priceDirection],
    title = _PRICE_MOBILE$priceDi.title,
    description = _PRICE_MOBILE$priceDi.description,
    buttonText = _PRICE_MOBILE$priceDi.buttonText;
  return /*#__PURE__*/_react["default"].createElement(StyledPriceChangePopup, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Title, null, title), /*#__PURE__*/_react["default"].createElement(Description, null, description), /*#__PURE__*/_react["default"].createElement(PriceDiff, null, /*#__PURE__*/_react["default"].createElement(OldPrice, null, /*#__PURE__*/_react["default"].createElement(PriceTitle, null, "\u0421\u0442\u0430\u0440\u0430\u044F \u0446\u0435\u043D\u0430"), /*#__PURE__*/_react["default"].createElement(Amount, {
    value: oldPrice
  })), /*#__PURE__*/_react["default"].createElement(Separator, null, /*#__PURE__*/_react["default"].createElement(Arrow, null)), /*#__PURE__*/_react["default"].createElement(NewPrice, null, /*#__PURE__*/_react["default"].createElement(PriceTitle, null, "\u0424\u0438\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0446\u0435\u043D\u0430"), /*#__PURE__*/_react["default"].createElement(Amount, {
    value: newPrice
  }))), /*#__PURE__*/_react["default"].createElement(Buttons, null, isIncreased && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(HotelLinkWrapper, null, hotelLink && /*#__PURE__*/_react["default"].createElement(HotelLink, {
    as: "a",
    functional: true,
    href: hotelLink,
    target: "_blank",
    className: "no-handle"
  }, "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u0440\u0443\u0433\u0438\u0435 \u0442\u0443\u0440\u044B"))), /*#__PURE__*/_react["default"].createElement(PaymentButton, {
    primary: true,
    size: "flex",
    onClick: onOrderConfirmed,
    priceDecreased: isIncreased
  }, isIncreased && /*#__PURE__*/_react["default"].createElement(FireIcon, null), buttonText, /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    prefix: " \u0437\u0430 ",
    value: newPrice
  }))));
};
var StyledPriceChangePopup = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupMobile__StyledPriceChangePopup",
  componentId: "sc-1l2z6ia-0"
})(["width:300px;padding:8px;display:flex;flex-direction:column;align-items:center;background-color:#fff;text-align:center;"]);
var Separator = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupMobile__Separator",
  componentId: "sc-1l2z6ia-1"
})(["display:flex;align-items:center;justify-content:center;min-width:32px;margin:0 10px;"]);
var Arrow = (0, _styledComponents["default"])(_ArrowRightLong["default"]).withConfig({
  displayName: "PriceChangePopupMobile__Arrow",
  componentId: "sc-1l2z6ia-2"
})(["width:32px;margin-top:13px;"]);
var Title = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupMobile__Title",
  componentId: "sc-1l2z6ia-3"
})(["font-size:20px;line-height:24px;margin-bottom:8px;color:#17181a;font-weight:500;max-width:308px;"]);
var Description = _styledComponents["default"].p.withConfig({
  displayName: "PriceChangePopupMobile__Description",
  componentId: "sc-1l2z6ia-4"
})(["font-size:15px;line-height:18px;margin-bottom:9px;color:#4d4d4d;white-space:break-spaces;"]);
var PriceDiff = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupMobile__PriceDiff",
  componentId: "sc-1l2z6ia-5"
})(["display:flex;margin-bottom:16px;justify-content:space-around;min-width:auto;"]);
var Amount = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "PriceChangePopupMobile__Amount",
  componentId: "sc-1l2z6ia-6"
})(["font-size:20px;line-height:24px;"]);
var OldPrice = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupMobile__OldPrice",
  componentId: "sc-1l2z6ia-7"
})(["color:#4d4d4d;font-weight:normal;"]);
var NewPrice = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupMobile__NewPrice",
  componentId: "sc-1l2z6ia-8"
})(["color:#17181a;", "{font-weight:500;}"], Amount);
var PriceTitle = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupMobile__PriceTitle",
  componentId: "sc-1l2z6ia-9"
})(["font-size:13px;line-height:16px;"]);
var Buttons = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupMobile__Buttons",
  componentId: "sc-1l2z6ia-10"
})(["display:flex;justify-content:center;flex-direction:column-reverse;"]);
var PaymentButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "PriceChangePopupMobile__PaymentButton",
  componentId: "sc-1l2z6ia-11"
})(["min-width:284px;margin-bottom:18px;font-size:18px;"]);
var FireIcon = (0, _styledComponents["default"])(_HotPriceCircle["default"]).withConfig({
  displayName: "PriceChangePopupMobile__FireIcon",
  componentId: "sc-1l2z6ia-12"
})(["width:16px;height:16px;margin-right:4px;margin-bottom:-3px;"]);
var HotelLinkWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PriceChangePopupMobile__HotelLinkWrapper",
  componentId: "sc-1l2z6ia-13"
})(["min-width:125px;"]);
var HotelLink = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "PriceChangePopupMobile__HotelLink",
  componentId: "sc-1l2z6ia-14"
})(["color:#007aff;text-decoration:none;outline:none;"]);